import { useAppSelector } from '@frontend/common';
import { ProductTypeConstraintData, isProductTypeConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ProductTypeConstraintDataInputProps } from './product-type-constraint-data-input.component';

interface ViewProps {
    formValues: ProductTypeConstraintData;
}

const useProductTypeConstraintDataInput = (props: ProductTypeConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isProductTypeConstraintData(formValues)) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { type: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useProductTypeConstraintDataInput;
